import { MeetingContent } from "data/@types/GlobalSearchData";
import { MeetingTableRow } from "data/@types/GlobalSearchMeetingTable";

export const transformMeetingRow = (
  meeting: MeetingContent,
): MeetingTableRow => {
  const entityNameDisplay =
    meeting.entityType === "Firm"
      ? meeting.firm?.longName
      : meeting?.entity?.longName;

  const entityIdDisplay = meeting?.entity?.id ?? meeting.firm?.id;

  const firmLegacyId =
    meeting?.universe === "Public"
      ? meeting?.firm?.imisId
      : meeting?.firm?.aadbId;

  const entityLegacyIdDisplay = meeting?.entity?.legacyId ?? firmLegacyId;

  return {
    ...meeting,
    entityName: entityNameDisplay ?? "",
    entityId: entityIdDisplay,
    entityLegacyId: entityLegacyIdDisplay,
    scheduledById: meeting.authorPerson.id,
    meetingLink: meeting.customTitle || meeting.title,
    caLeaders: meeting.participants
      .filter((p) => p.type === "CALeader")
      .map((p) => `${p.firstName} ${p.lastName}`)
      .join(", "),
    caParticipants: meeting.participants
      .filter((p) => p.type === "CAParticipant")
      .map((p) => `${p.firstName} ${p.lastName}`)
      .join(", "),
    managerParticipants: meeting.participants
      .filter((p) => p.type === "ManagerParticipant")
      .map((p) => `${p.firstName} ${p.lastName}`)
      .join(", "),
    responsibleWriters: meeting.participants
      .filter((p) => p.type === "ResponsibleWriter")
      .map((p) => `${p.firstName} ${p.lastName}`)
      .join(", "),
    caOffice: meeting.location?.caOffice ?? "",
    meetingLocation: meeting.location?.type ?? "",
    managerLocation: meeting.location?.managerLocation ?? "",
    createdByPersonName: meeting.createdByPerson?.name,
    updatedByPersonName: meeting.updatedByPerson?.name,
    otherManagers: meeting.otherManagerRep,
    otherMeetingAttendees: meeting.otherMeetingAttendees,
    otherLocation: meeting.location?.other ?? "",
    otherCountry: meeting.location?.otherCountry ?? "",
    createdById: meeting?.createdByPerson?.id,
    updatedById: meeting?.updatedByPerson?.id,
  };
};
